import React from 'react';
import SearchableInventorySupplierDropdown from '../../Common/SearchableInventorySupplierDropdown';

const PaymentFormHeader = ({
  formData,
  onChange,
  onSupplierChange,
  supplierLabel = '',
  errors = {},
  loading = false
}) => {
  return (
    <div className="border border-gray-200 rounded-lg mb-3 overflow-hidden">
      <div className="flex items-center bg-gradient-to-r from-indigo-600 to-purple-600 px-3 py-1.5">
        <span className="text-xs font-semibold text-white">Payment Details</span>
      </div>

      <div className="px-3 py-2">
        <div className="grid grid-cols-4 gap-2">
          {/* Payment Date */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Payment Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="paymentDate"
              value={formData.paymentDate || ''}
              onChange={onChange}
              className={`w-full px-2 py-1.5 text-xs border rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 ${
                errors.paymentDate ? 'border-red-300 bg-red-50' : 'border-gray-300'
              }`}
            />
            {errors.paymentDate && (
              <p className="text-xs text-red-500 mt-0.5">{errors.paymentDate}</p>
            )}
          </div>

          {/* Supplier */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Supplier <span className="text-red-500">*</span>
            </label>
            <SearchableInventorySupplierDropdown
              value={formData.supplier}
              displayLabel={supplierLabel}
              onChange={onSupplierChange}
              placeholder="Select Supplier"
              disabled={loading}
              error={!!errors.supplier}
              menuPlacement="down"
            />
            {errors.supplier && (
              <p className="text-xs text-red-500 mt-0.5">{errors.supplier}</p>
            )}
          </div>

          {/* Supplier Code */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Supplier Code</label>
            <input
              type="text"
              name="supplierCode"
              value={formData.supplierCode || ''}
              onChange={onChange}
              placeholder="Auto-filled"
              disabled
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-gray-100 text-gray-500"
            />
          </div>

          {/* Payment Type */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Payment Type</label>
            <select
              name="paymentType"
              value={formData.paymentType || 'against_grn'}
              onChange={onChange}
              disabled={loading}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="against_grn">Against GRN</option>
              <option value="advance">Advance</option>
              <option value="on_account">On Account</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFormHeader;
